"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _OptionalComponentToggle = _interopRequireDefault(require("../OptionalComponentToggle"));
var _DropdownField = _interopRequireDefault(require("../DropdownField"));
var _TextField = _interopRequireDefault(require("../TextField"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const getComponentByType = _ref => {
  let {
    component,
    handleOnChange,
    components,
    style
  } = _ref;
  const {
    field,
    type,
    label,
    default: defaultValue,
    options,
    info,
    parent,
    caption,
    initialValue
  } = component;
  if (!components[field]) {
    return;
  } else if (type === 'dropdown') {
    return /*#__PURE__*/_react.default.createElement(_DropdownField.default, {
      key: field,
      options: options,
      selected: components[field],
      onChange: handleOnChange(field),
      caption: caption
    });
  } else if (type === 'text') {
    return /*#__PURE__*/_react.default.createElement(_TextField.default, {
      key: label + type,
      label: label,
      onChange: handleOnChange(field),
      initialValue: initialValue,
      caption: caption
    });
  } else {
    const {
      enabled,
      readOnly
    } = components[field];
    const parentComponent = components[parent];
    if (parentComponent?.enabled || !parent) {
      return /*#__PURE__*/_react.default.createElement(_OptionalComponentToggle.default, {
        key: field,
        name: field,
        label: label,
        info: info,
        default: defaultValue,
        onChange: handleOnChange(field),
        isToggled: enabled,
        readOnly: readOnly,
        components: components,
        style: style,
        options: options,
        hasParent: Boolean(parent),
        caption: caption
      });
    } else {
      return null;
    }
  }
};
var _default = exports.default = getComponentByType;